import { createFileRoute } from '@tanstack/react-router';
import { SeoLayout } from '@/components/astro/new-design-25/SEO/seo-layout';
import { seo } from '@/seo/seo';

const heroTitle = 'Text to Speech for Dyslexia';
const heroDescription =
  'Assistive text to speech technology designed for dyslexic learners. Natural voices help overcome reading challenges and improve comprehension and learning outcomes.';

const featureTitle = heroTitle;
const featureSubtitle = 'Accessible learning support';
const featureDescription = heroDescription;
const featureBadge = 'Accessibility';
const featureVariant = 'default';
const featureCtaText = 'Access Learning Tools';

const featureFeatures = [
  {
    title: 'Reading Comprehension Support',
    description:
      'Hear text while following along visually to improve understanding and reduce reading fatigue.',
  },
  {
    title: 'Adjustable Reading Speed',
    description:
      'Control playback speed to match your learning pace and processing preferences.',
  },
  {
    title: 'Multi-Sensory Learning',
    description:
      'Combine auditory and visual input to strengthen reading skills and build confidence.',
  },
];

export const Route = createFileRoute(
  '/_marketing/_seo/text-to-speech-for-dyslexia',
)({
  head: () => ({
    meta: [
      ...seo({
        title:
          'Text to Speech for Dyslexia - Assistive Reading Technology | Listening',
        description:
          'Text to speech tools designed for dyslexic learners. Natural AI voices help overcome reading challenges and improve comprehension. Accessible learning support.',
      }),
    ],
  }),
  component: () => (
    <SeoLayout
      featureBadge={featureBadge}
      featureCtaText={featureCtaText}
      featureDescription={featureDescription}
      featureFeatures={featureFeatures}
      featureSubtitle={featureSubtitle}
      featureTitle={featureTitle}
      featureVariant={featureVariant}
      pageDescription={heroDescription}
      pageTitle={heroTitle}
    />
  ),
});
